import { steps, } from "../DUCProcess";
import Attestation from "../AttestationStep";
import Recipients from "../Recipients";
import Statement from "../Statement";
import Renewal from "../Renewal";
import AuthorizedOfficial from "../AuthorizedOfficial";
import SubRecipients from "../SubRecipients";
import Review from "../Review";

export const constructDucFlowBasedFromState = (isExpired: boolean, isAttestion: boolean, isGroup: boolean): steps[] => {
    const flow: steps[] = []
    flow.push(steps.RECIPIENTS)
    flow.push(steps.STATEMENT)
    if(isExpired){
        flow.push(steps.RENEWAL)
    }
    if(isAttestion){
        flow.push(steps.ATTESTATION)
    }
    if(isGroup){
        flow.push(steps.SUBRECIPIENTS)
    }
    flow.push(steps.AUTHORIZEDOFFICIAL)
    flow.push(steps.REVIEW)
    return flow
}

export const constructStepLabelsFromState = (flow: steps[]): string[] => {
    return flow.map((step) => {
        switch (step) {
        case steps.RECIPIENTS: {
            return "ACCESS REQUEST"
        }
        case steps.STATEMENT: {
            return "RESEARCH DATA USE STATEMENT"
        }
        case steps.RENEWAL: {
            // During renewals this step hosts the Progress Report Statement textarea
            return  "RENEWAL"
        }
        case steps.ATTESTATION: {
            return  "ATTESTATION"
        }
        case steps.SUBRECIPIENTS: {
            return  "SUB-APPLICANTS"
        }
        case steps.AUTHORIZEDOFFICIAL: {
            return  "AUTHORIZED INSTITUTIONAL BUSINESS OFFICIAL"
        }
        case steps.REVIEW: {
            return  "REVIEW"
        }
        }
    });
}


export const RenderCurrentDucStep = (props: any) => {
    // Use a single source of truth for renewal detection during render.
    // Prefer parent-provided `props.isRenewal`. Fallback to DUCInfo.type or props.expiry for backward compatibility.
    const isRenewal = typeof props.isRenewal === 'boolean' ? props.isRenewal : ((props?.DUCInfo?.type === 'Renewal') || !!props.expiry)
    const flow = constructDucFlowBasedFromState(isRenewal, props.attestation, props.isGroup)
    const curStepName = flow[props.step -1]
    switch (curStepName) {
    case steps.ATTESTATION:
        return (
            <Attestation
                curStep={props.curStep}
                setCurStep={props.setCurStep}
                DUCInfo={props.DUCInfo}
                prevData={props.prevData}
                setDUCInfo={props.setDUCInfo}
                stepLabels={props.stepLabels}/>
        )
    case steps.RECIPIENTS:
        return (
            <Recipients
                curStep={props.curStep}
                setCurStep={props.setCurStep}
                DUCInfo={props.DUCInfo}
                prevData={props.prevData}
                setDUCInfo={props.setDUCInfo}
                stepLabels={props.stepLabels}/>
        )
    case steps.STATEMENT:
        return (
            <Statement
                curStep={props.curStep}
                setCurStep={props.setCurStep}
                prevData={props.prevData}
                DUCInfo={props.DUCInfo}
                setDUCInfo={props.setDUCInfo}
                stepLabels={props.stepLabels}
                setFromStatement={props.setFromStatement}
                ducType={props.formType}/>
        )
    case steps.RENEWAL:
        return (
            <Renewal
                curStep={props.curStep}
                setCurStep={props.setCurStep}
                prevData={props.prevData}
                DUCInfo={props.DUCInfo}
                setDUCInfo={props.setDUCInfo}
                stepLabels={props.stepLabels}/>
        )
    case steps.AUTHORIZEDOFFICIAL:
        return (
            <AuthorizedOfficial
                curStep={props.curStep}
                setCurStep={props.setCurStep}
                stepLabels={props.stepLabels}
                prevData={props.prevData}
                DUCInfo={props.DUCInfo}
                setDUCInfo={props.setDUCInfo}
                attestation={props.attestation}
                isEdit={props.isEdit}
                isSub={props.isSub}
                type={props.formType}
                data={props.data}
                isGroup={props.isGroup}
                refetch={props.refetch}
                expiry={props.expiry}
                isRenewal={isRenewal}
                fromStatement={props.fromStatement}
                isAddSub={props.isAddSub}
                isSecond={props.isSecond}
                setSubmitting={props.setSubmitting}/>
        )
    case steps.SUBRECIPIENTS:
        return (
            <SubRecipients
                curStep={props.curStep}
                setCurStep={props.setCurStep}
                prevData={props.prevData}
                DUCInfo={props.DUCInfo}
                isEdit={props.isEdit}
                type={props.formType}
                data={props.data}
                setDUCInfo={props.setDUCInfo}
                stepLabels={props.stepLabels}
                expiry={props.expiry}
                isAddSub={props.isAddSub}
                isSecond={props.isSecond}
                username={props.username}/>
        )
    case steps.REVIEW:
        return (
            <Review
                curStep={props.curStep}
                prevData={props.prevData}
                setCurStep={props.setCurStep}
                type={props.formType}
                data={props.data}
                stepLabels={props.stepLabels}
                expiry={props.expiry}
                isSub={props.isSub}
            />
        )
    }
}





